import React from 'react';
import JustificationContainer, {
  type Props as JustificationProps,
} from '~/components/atom/JustificationContainer';
import { Body, Label } from '~/components/atom/Typography';

export type Props = {
  dataTestId?: string;
  className?: string;
  justificationProps?: JustificationProps;
  labelWidth?: string;
  label: React.ReactNode;
  value: React.ReactNode;
};

const TypographyPair: React.FCC<Props> = ({
  dataTestId,
  className,
  justificationProps = { align: 'center' },
  label,
  value,
  labelWidth = '80px',
}) => (
  <JustificationContainer
    {...justificationProps}
    dataTestId={dataTestId}
    className={className}
  >
    <Label size="s" margin={[null]} width={labelWidth}>
      {label}
    </Label>
    <Body size="s" margin={[null]} width="max-content">
      {value}
    </Body>
  </JustificationContainer>
);

export default TypographyPair;
